/*
  CUSTOM ADDITION — added [29. July 2026] by [OH]
  Purpose: Normalizes product description text regardless of how
  it was manually entered:
  - Converts every sentence to lowercase, then capitalizes the
    first letter of each sentence (true sentence case, not just
    the first sentence of the paragraph).
  - Converts lines starting with common bullet characters (-, *,
    •, –, —) into real <ul><li> bullet points, if not already
    formatted as a list.
  - Leaves existing <ul>/<li> elements untouched.
  - Leaves links, bold tags, etc. structurally intact — only the
    text content is modified, not the HTML structure (except for
    the dash-to-bullet conversion).
  To remove: delete this file and its <script> include in
  sections/main-product.liquid (search "product-description-normalize").
*/

(function () {
  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function processTextNode(node, productTitle) {
    if (node.nodeValue.trim() === '') return;
    var text = node.nodeValue;

    text = text.replace(/\bmubi\b/gi, function (match) {
      return match.toUpperCase();
    });

    if (productTitle) {
      var titlePattern = new RegExp(escapeRegExp(productTitle), 'gi');
      text = text.replace(titlePattern, function (match) {
        return match.toUpperCase();
      });
    }

    node.nodeValue = text;
  }

  function walkTextNodes(element, productTitle) {
    for (var i = 0; i < element.childNodes.length; i++) {
      var child = element.childNodes[i];
      if (child.nodeType === Node.TEXT_NODE) {
        processTextNode(child, productTitle);
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        walkTextNodes(child, productTitle);
      }
    }
  }

  function convertDashesToBullets(container) {
    var bulletPattern = /^\s*[-*•–—]\s+/;
    var paragraphs = container.querySelectorAll('p');
    var currentList = null;

    paragraphs.forEach(function (p) {
      var text = p.textContent || '';

      if (bulletPattern.test(text)) {
        if (!currentList) {
          currentList = document.createElement('ul');
          p.parentNode.insertBefore(currentList, p);
        }

        var li = document.createElement('li');
        li.innerHTML = p.innerHTML.replace(bulletPattern, '');
        currentList.appendChild(li);
        p.remove();
      } else {
        currentList = null;
      }
    });
  }

  function normalizeDescriptions() {
    var containers = document.querySelectorAll('.product-description-normalized');

    containers.forEach(function (container) {
      convertDashesToBullets(container);
      var productTitle = container.getAttribute('data-product-title');
      walkTextNodes(container, productTitle);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalizeDescriptions);
  } else {
    normalizeDescriptions();
  }
})();